export default __webpack_public_path__ + "static/media/AI-project-image.a4d442e8.svg";